import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ReportingService {

    constructor(
        private http: HttpClient
    ) { }

    // Get all Stores
    public getPromoReport(storeId, amount, start, end) {


        return this.http.get(environment.apiUrl + `api/ext-reporting/${storeId}/users?value=${amount}&startDate=${start}&endDate=${end}`, { observe: 'response' })
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }


    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res.body;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/reporting.service.ts